"use client"
import { Box } from '@chakra-ui/react'
import PCFCTable from './components/PCFCTable/PCFCTable'

const PcFc = () => {
  return (
    <Box>
        <PCFCTable/>
    </Box>
  )
}

export default PcFc